import Api from 'libs/api/index';
import axios from 'axios';
import AuthService from 'services/Auth';

class AcademyLogsApi extends Api {
  constructor() {
    super('retail_academy/retail_academy_logs/');
  }

  getExcel(params) {
    const apiUrl = process.env.REACT_APP_API_URL;
    return axios({
      url: `${apiUrl}/retail_academy/retail_academy_logs.xlsx`,
      method: 'get',
      data: params.data,
      params: params.params,
      responseType: 'blob', // important
      headers: {
        'Content-Type': 'application/json',
        ...(params?.headers || {}),
        'auth-token': AuthService.getToken(),
      },
    });
  }
}

export default AcademyLogsApi;
